import { normalizeShopifyExternalId } from './shopifyExternalId';
import { normalizeSquarespaceExternalId } from './squarespaceExternalId';

/** Stands in for the access token until a Squarespace merchant connects. */
export const SQUARESPACE_PENDING_CONNECT_TOKEN = 'pending-connect';

/** Ecommerce credential `data` from Create Merchant and the onboarding wizard. */
export type EcommerceConnectorData = {
  externalId: string;
  apiVersion: string;
  configuration: Record<string, unknown>;
};

/** The platform's store identifier, or null when the input is not one. */
export const normalizeEcommerceExternalId = (platform: string, raw: string): string | null => {
  if (platform === 'shopify') {
    return normalizeShopifyExternalId(raw);
  }
  if (platform === 'squarespace') {
    return normalizeSquarespaceExternalId(raw);
  }
  return raw.trim() || null;
};

/**
 * Credential data before connect, from a normalized `externalId`. Squarespace gets a placeholder
 * `shopUrl` and `token` because MMS requires both; ecom-connector replaces them on connect.
 */
export const buildEcommerceConnectorData = (
  platform: string,
  externalId: string,
): EcommerceConnectorData => ({
  externalId,
  apiVersion: 'v1',
  configuration:
    platform === 'squarespace'
      ? {
          shopUrl: `https://${externalId}.squarespace.com`,
          token: SQUARESPACE_PENDING_CONNECT_TOKEN,
        }
      : {},
});
